import { request } from "../utils/axios";
import {
    getSessionId,
    setSessionData,
    getSessionData,
    getShadowRoot,
} from "../utils/store";
import { nextPrev } from "../utils/StepService";
import { setLoading, setError } from "../utils";

class FaceCaptureOptions {
    consentDetails;
    render = async () => {
        const sessionData = getSessionData();
        let modalBox = getShadowRoot().querySelector("#identity-modal__box");
        if (modalBox.querySelector("#faceCaptureoptions")) return;
        modalBox.insertAdjacentHTML(
            "beforeend",
            `<form class="form-content" id="faceCaptureoptions" data-form-tab>
                                <h2 class="identity__text-center"   > Face Capture Option</h2>
                                  <div class="identity__text-center">
                                <svg class="svg" width="74px" height="74px" aria-hidden="true" role="img"><use href="#svg__success" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg__success"></use></svg>
                                </div>

                                 <div class="identity__row">
                                <div class="identity__col-12">
                                    <p class="identity__text-center identity__mt0">                               Your selfie has been verified successfully.
                                </div>
                                </div>
                                  <div class="identity__row">
                              ${sessionData.configurationType !== 2 ? `   <div class="identity__col-12">
                                    <p class="identity__text-center identity__mt0">Would you like to continue with hands-free face verification?
                                </div>`: ""} 
                                </div>
                                <div class="identity__col-12">
                                    <div class="identity-field">
                                      <button class="identity-btn" id="btn-continue" type="submit" >Continue 
                                       <span class="loading-icon">
                                                <svg class="svg" width="20px" height="20px" aria-hidden="true" role="img">
                                                  <use href="#svg__loader" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg__loader"></use>
                                                </svg>
                                              </span>
                                      </button>
                                    </div>
                                  </div>
                                ${sessionData.configurationType !== 2 ? ` <div class="identity__col-12">
                                  <div class="identity-field ">
                                    <button type="button"   
                                    class="identity-btn identity-btn__secondary"
                                    id="skip" >Skip
                                     </button>
                                </div>
                                </div> `: ""} 
                            </form>`
        );

        this.bindEvents(sessionData);
    };

    bindEvents(sessionData) {
        const faceCaptureoptionsForm = getShadowRoot().querySelector("#faceCaptureoptions");
        const skipButton = faceCaptureoptionsForm.querySelector("#skip");
        const continueButton = faceCaptureoptionsForm.querySelector("#btn-continue");
        const title = getShadowRoot().querySelector(`#identityLeftMessage`);
        title.style.display = 'none';
        faceCaptureoptionsForm.addEventListener("submit", (event) => {
            setLoading(true);
            this.SendOption(true, this.consentDetails);
            event.preventDefault();
        });

        if (sessionData.configurationType !== 2) {
            skipButton.addEventListener("click", () => {
                setLoading(false);
                this.SendOption(false);
            })
        }
    }

    SendOption(hasUserMultipleImage) {
        request
            .post(`/facecaptureoptions/${getSessionId()}`, {
                hasUserMultipleImage: hasUserMultipleImage,
            })
            .then(({ data }) => {
                setSessionData(data.data);
                nextPrev(1);
            })
            .catch(({ response }) => {
                setError(response);
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    }
}

export default FaceCaptureOptions;
